var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('HomeBanner',{attrs:{"lift":_vm.lift,"aspectRatio":_vm.heroAspectRatio,"sizes":"(max-width: 480px) 300px, 600px","textRight":"","noAction":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }